export default {
  priv: 'pr_device',
  detailTitle: '',
  deleteTitle: 'dit item',
  overviewUrl: '/devices/types/{type_id}',
  url: '/devices/types/{type_id}/lines',
  apiUrl: '/devicetypes/{type_id}/lines/'
};
